import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateLocalePipe } from '../pipes/date-locale.pipe';
import { DialogComponent } from './dialog/dialog.component';
import { ErrorInfoComponent } from './error-info/error-info.component';
import { NbButtonModule, NbCardModule, NbTooltipModule, NbProgressBarModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DateLocalePipe, DialogComponent, ErrorInfoComponent],
  exports: [DateLocalePipe, DialogComponent, ErrorInfoComponent, NbTooltipModule, NbProgressBarModule],
  imports: [
    CommonModule,
    NbCardModule,
    NbButtonModule,
    TranslateModule,
    NbTooltipModule,
    NbProgressBarModule
  ]
})
export class SharedModule { }
